module.exports = __webpack_public_path__ + "img/cropped-Favicon_CrediTú-180x180.01d77334.png";